import { cognitoUserInGroup } from '@akin-home/auth/frontend';
import { useAuthStore } from '@akin-home/auth/react';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { isWebBuild } from './isWebBuild';

export const isRobotUser = () => {
  if (isWebBuild()) {
    return false;
  }

  const auth_user = useAuthStore.getState().auth_user;

  return cognitoUserInGroup(CognitoUserGroup.ROBOT_USERS)(auth_user) ?? false;
};
